import type { Action } from './action';
import type { State } from './type';

import { ActionType } from './action';
import { NOOPModal } from './state';

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionType.OpenModal:
      return {
        modal: action.payload,
      };
    case ActionType.CloseModal:
      return {
        modal: NOOPModal,
      };
    default:
      return state;
  }
};
